import { faChevronLeft, faFaceUnamused } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { useGetPayStation } from 'src/features/payStations/api/useGetPaystation';
import { InformationDashboard } from 'src/features/payStations/components/InformationDashboard';
import payStationsMessages from 'src/features/payStations/utils/messages';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import { Button } from 'src/registry/ui/Button';

const Information = () => {
    const { formatMessage } = useIntl();
    const { payStationId } = useParams();

    const {
        data: payStationData,
        isLoading,
        isError,
    } = useGetPayStation({
        payStationId: payStationId || '',
        config: { enabled: !!payStationId },
    });

    return (
        <>
            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to="/pay-stations">
                    <FontAwesomeIcon icon={faChevronLeft} className="opacity-50" />
                    {formatMessage(payStationsMessages.backToAllPayStationDevices)}
                </Link>
            </Button>
            {isError ? (
                <div className="pointer-events-none flex size-full flex-1 flex-col items-center justify-center pb-40">
                    <GeneralMessageBlock
                        className="py-12"
                        variant="error"
                        icon={faFaceUnamused}
                        title={formatMessage(payStationsMessages.deviceNotFound)}
                        subtitle={formatMessage(payStationsMessages.deviceNotFoundDescription)}
                    />
                </div>
            ) : (
                <InformationDashboard payStationData={payStationData} isLoading={isLoading} />
            )}
        </>
    );
};
export { Information };
